import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsConventions from './enpoints'

const ConventionsService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsConventions.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsConventions.LOAD_BY_ID(id)),
  create: async (body) => POST(endpointsConventions.CREATE, body),
  update: async ({ _id, body }) =>
    PATCH(endpointsConventions.LOAD_BY_ID(_id), body),
  remove: async (id) => DELETE(endpointsConventions.LOAD_BY_ID(id)),
}

export default ConventionsService
